import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchSelectedUsertext } from "../../../store/formsubmitted";
import { RootState } from "../../../store/rootReducer";

export const UserSelectedSearchBar = () => {
    const dispatch = useDispatch();
    const selectedSearchText = useSelector((state: RootState) => state.formSubmittedSlice.searchSelectedUserText);

    return (
        <IonSearchbar
            value={selectedSearchText}
            onIonChange={({ detail: { value = "" } }) => {
                dispatch(setSearchSelectedUsertext(value));
            }}
            debounce={700}
            placeholder={"Buscar en usuarios seleccionados..."}
            autocomplete="off"
        />
    );
};
